import LegalLayout, { Section, P, List } from "./LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="June 12, 2026">
      <Section heading="Agreement to Terms">
        <P>
          These Terms of Service (&ldquo;Terms&rdquo;) govern your access to and
          use of the website at doomade.com (the &ldquo;Site&rdquo;) operated by
          DOO MADE Inc. (&ldquo;DOO MADE,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo;
          or &ldquo;our&rdquo;). By accessing or using the Site, you agree to be
          bound by these Terms. If you do not agree, please do not use the Site.
        </P>
      </Section>

      <Section heading="Use of the Site">
        <P>You agree to use the Site lawfully and not to:</P>
        <List
          items={[
            "Use the Site in any way that violates applicable laws or regulations.",
            "Attempt to gain unauthorized access to the Site, its servers, or related systems.",
            "Interfere with or disrupt the operation, security, or availability of the Site.",
            "Copy, scrape, or reproduce Site content except as permitted below.",
          ]}
        />
      </Section>

      <Section heading="Our Services">
        <P>
          The Site describes DOO MADE&rsquo;s AI systems design and integration
          services and lets you book an introductory call. The Site itself does
          not constitute an offer, contract, or guarantee of work. Any engagement
          for paid services is governed by a separate written agreement between
          you and DOO MADE that defines the scope, deliverables, fees, and terms
          of that specific engagement. Pricing shown on the Site is indicative and
          may change; final pricing is confirmed in that separate agreement.
        </P>
      </Section>

      <Section heading="Intellectual Property">
        <P>
          The Site and its content &mdash; including text, design, graphics, logos,
          and the DOO MADE name and brand &mdash; are owned by DOO MADE Inc. or its
          licensors and are protected by intellectual property laws. You may view
          and share the content for personal, non-commercial purposes, but you may
          not reproduce, distribute, or create derivative works from it without our
          prior written permission.
        </P>
      </Section>

      <Section heading="Third-Party Links and Services">
        <P>
          The Site links to third-party services such as Calendly, YouTube,
          Substack, and Discord. We do not control these services and are not
          responsible for their content, availability, or practices. Your use of
          them is governed by their own terms and policies.
        </P>
      </Section>

      <Section heading="Disclaimers">
        <P>
          The Site and its content are provided on an &ldquo;as is&rdquo; and
          &ldquo;as available&rdquo; basis, without warranties of any kind, whether
          express or implied, including warranties of merchantability, fitness for
          a particular purpose, and non-infringement. We do not warrant that the
          Site will be uninterrupted, error-free, or secure, or that any
          information on it is complete or current. Nothing on the Site is
          professional, legal, or financial advice.
        </P>
      </Section>

      <Section heading="Limitation of Liability">
        <P>
          To the fullest extent permitted by law, DOO MADE Inc. and its directors,
          officers, employees, and contractors will not be liable for any
          indirect, incidental, special, consequential, or punitive damages, or
          any loss of profits, data, or goodwill, arising from your use of or
          inability to use the Site. Our total liability for any claim relating to
          the Site is limited to one hundred Canadian dollars (CAD $100).
        </P>
      </Section>

      <Section heading="Indemnification">
        <P>
          You agree to indemnify and hold harmless DOO MADE Inc. from any claims,
          damages, liabilities, and expenses arising out of your use of the Site or
          your violation of these Terms.
        </P>
      </Section>

      <Section heading="Governing Law">
        <P>
          DOO MADE Inc. is a federally incorporated Canadian corporation. These
          Terms are governed by the federal laws of Canada and the laws of the
          Province of British Columbia applicable therein, without regard to
          conflict-of-law principles. You agree that the courts located in British
          Columbia, Canada will have exclusive jurisdiction over any dispute
          arising from these Terms or your use of the Site.
        </P>
      </Section>

      <Section heading="Changes to These Terms">
        <P>
          We may update these Terms from time to time. When we do, we will revise
          the &ldquo;Last updated&rdquo; date at the top of this page. Your
          continued use of the Site after changes take effect constitutes
          acceptance of the revised Terms.
        </P>
      </Section>

      <Section heading="Contact Us">
        <P>
          Questions about these Terms can be directed to DOO MADE Inc. at{" "}
          <a
            href="mailto:daniel.jindoo@doomade.com"
            className="text-chalk border-b border-acid/40 hover:text-acid-soft hover:border-acid transition-colors duration-200"
          >
            daniel.jindoo@doomade.com
          </a>
          .
        </P>
      </Section>
    </LegalLayout>
  );
}
